import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

/**
 * Where the admin guard sends an admin with no session: the admin login, then on to the page
 * they opened.
 */
@Component({
  templateUrl: "./pageeditlogin.component.html",
})
export class PageEditLoginComponent implements OnInit, OnDestroy {
  routerParams: Subscription;
  id: number = 0;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.routerParams = this.activatedRoute.params.subscribe(params => {
      this.id = +params["id"]; // (+) converts string 'id' to a number
    });
  }

  ngOnDestroy() {
    this.routerParams.unsubscribe();
  }

  onLoggedIn(): void {
    this.router.navigate(["edit", this.id]);
  }
}
